import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

import { computed, onMounted } from "vue";
import { ProjectActions, ProjectGetters } from "@/store/modules/project";
import { useStore } from "vuex";
import { Project } from "@/store/modules/project/types";
import { TaskMutations } from "@/store/modules/task";


import { defineComponent } from "vue";

const __default__ = defineComponent({
    name: "LoaderGenerateProjList",
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


const store = useStore();
const projectList = computed(() => {
    return store.getters[`project/${ProjectGetters.getOwnProjectList}`];
});
const isLoading = computed(() => {
    return store.getters[`project/${ProjectGetters.getLoading}`];
});

const handleRowClick = (row: Project) => {
    store.commit(`task/${TaskMutations.setSelectedProj}`, row.id);
}

onMounted(async () => {
    await store.dispatch(`project/${ProjectActions.asyncGetOwnProjectList}`);
});


return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_el_table, {
    class: "TaskProjectList",
    data: _unref(projectList),
    "highlight-current-row": true,
    onRowClick: handleRowClick,
    "row-class-name": "loaderGenerateProjList--hover"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table_column, {
        align: "center",
        prop: "id",
        label: "ID",
        "show-overflow-tooltip": true
      }),
      _createVNode(_component_el_table_column, {
        align: "center",
        prop: "name",
        label: "名称",
        "show-overflow-tooltip": true
      }),
      _createVNode(_component_el_table_column, {
        align: "center",
        prop: "description",
        label: "简介",
        "show-overflow-tooltip": true
      })
    ]),
    _: 1
  }, 8, ["data"])), [
    [_directive_loading, _unref(isLoading)]
  ])
}
}

})